import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=6ccfa0bd&scoped=true"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContacts.vue?vue&type=style&index=0&id=6ccfa0bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfa0bd",
  null
  
)

export default component.exports